import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { utils } from '../utils'
import { Slide, Zoom } from "react-awesome-reveal";
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { ActionProd_List } from '../store/action/action-product';
import { Action_addToCart } from '../store/action/action-cart';
import { Box, Card, CardActionArea, CardActions, CardContent, CardMedia, IconButton, Paper, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Alert from '@material-ui/lab/Alert';
import LoadingHook from './hooks/LoadingHook'; 3
import CloseIcon from '@material-ui/icons/Close';

class Products_Component extends Component {
    constructor(props) {
        super(props);
        this.state = {
            product: false,
        };

    }

    componentDidMount() {
        if (!this.props.products) {            
            this.props.ActionProd_List();
        }
    }

    render() {
        const { product } = this.state;

        if (this.props?.loading) {
            return <Slide direction='left'><LoadingHook /></Slide >
        }

        if (!this.props.products || this.props.products.length == 0) {
            return <Slide direction='left'>
                <Alert severity="info">No data: try gain</Alert>
            </Slide >
        }

        const baseImgUrl = utils.constants.S3_imgBaseURL;


        const css = {
            prodImg: {
                minHeight: '20rem',
            },
            ContentBox: { flexGrow: '8' },
            btnAdd: { border: '1px solid #ffc0cb', borderRadius: '4px' },

        }


        return (
            <Paper>
                {/* <Fade direction='bottom' cascade duration='180'> */}
                <ul className="products">
                    {
                        this.props.products.map((product) => (

                            <li key={product._id}>

                                <Slide >
                                    <div className="product">
                                        <Card>
                                            <a href={'#' + product._id} onClick={() => this.setState({ product })}>
                                                <CardMedia
                                                    style={css.prodImg}
                                                    image={baseImgUrl + product.seller + '/' + product.image}
                                                    // image={product.image}
                                                    title={product.title}
                                                />

                                            </a>

                                            <div className="flex-container">
                                                <CardActionArea style={css.ContentBox}>
                                                    <CardContent>
                                                        <Typography gutterBottom variant="h6" component="h6" style={{ fontSize: '1rem' }}>
                                                            {product.title}
                                                        </Typography>
                                                        <Typography variant="body2" component="p">
                                                            {utils.formateCurrency(product.price)}
                                                        </Typography>

                                                    </CardContent>
                                                </CardActionArea>

                                                <CardActions className='column-box, btn-box'>

                                                    <div className='prod-add-amount'> {product.count || ''} </div>

                                                    <IconButton color="secondary" aria-label="Add product"
                                                        style={css.btnAdd}
                                                        onClick={() => this.props.Action_addToCart(product)}>
                                                        <AddIcon />
                                                    </IconButton>

                                                </CardActions>
                                            </div>
                                        </Card>
                                    </div>
                                </Slide>

                            </li>

                        ))
                    }
                </ul>
                {/* </MuiSlide> */}
                {
                    this.state.product && (

                        <Modal isOpen={true}
                            ariaHideApp={false}
                            onRequestClose={() => this.state.product === null}>

                            <IconButton
                                onClick={() => this.setState({ product: null })}
                                color="primary"
                                style={{ float: 'right', zIndex: '999' }} >
                                <CloseIcon />
                            </IconButton>



                            <Zoom>
                                <div className="product-details">

                                    <img src={baseImgUrl + product.seller + '/' + product.image} alt={product.title}></img>
                                    <div className="product-details-description grow-parent">
                                        <div className='header'>
                                            {product.title}
                                        </div>
                                        <p className='content'>{product.description}</p>
                                        <div className='grow-1'>
                                            <fieldset className='fieldset'>
                                                <legend>Available @</legend>
                                                {product.availableSizes.map((x) => (
                                                    <Box key={x} bgcolor="text.disabled" color="background.paper" boxShadow={1} >
                                                        {x}
                                                    </Box>
                                                ))}
                                            </fieldset>
                                        </div>
                                        <div className="product-price">
                                            <div>{utils.formateCurrency(product.price)}</div>
                                            <IconButton color="secondary" aria-label="Add product"
                                                style={css.btnAdd}

                                                onClick={() => {
                                                    this.props.Action_addToCart(product);
                                                    this.setState({ product: null })
                                                }}
                                            >
                                                <AddIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                </div>

                            </Zoom>
                        </Modal>

                    )
                }
            </Paper>

        )
    }
}
Products_Component.propTypes = {
    // prod
    products: PropTypes.any,
    ActionProd_List: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    errorProd: PropTypes.string,
    // cart
    // cartItems: PropTypes.any,
    Action_addToCart: PropTypes.func.isRequired

}

export default connect(
    (state) => ({
        products: state.reducer_product.filterProducts,
        loading: state.reducer_product.loading,
        errorProd: state.reducer_product.error,
        // cartItems: state.reducer_cart.cartItems,
    }),
    {
        ActionProd_List,
        Action_addToCart
    })(Products_Component)